import defaultAttributes from '../defaultAttributes';

const Clock2 = [
  'svg',
  defaultAttributes,
  [
    ['circle', { cx: '12', cy: '12', r: '10' }],
    ['polyline', { points: '12 6 12 12 16 10' }],
  ],
];

export default Clock2;
